var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#white-rounded_svg__clip0_1210_18321)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "white-rounded_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 40,
  height: 41
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C8.954 40 0 31.047 0 20 0 8.955 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#white-rounded_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "url(#white-rounded_svg__paint0_linear_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "#3321A4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "url(#white-rounded_svg__paint1_radial_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "url(#white-rounded_svg__paint2_radial_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.105 1.515C26.93 19.601 9.713 40.472 3.86 40.058 57.415 49.287 41.617 13.636 44.234-.01H8.685c-.776 0-1.14.986-.58 1.524z",
  fill: "url(#white-rounded_svg__paint3_linear_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.546 17.085c1.05 22.623-20.865 29.216-26.795 28.829 36.775 8.173 60.351-17.346 62.97-29.92H26.56c-.583 0-1.04.51-1.013 1.091z",
  fill: "url(#white-rounded_svg__paint4_linear_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.546 17.085c1.05 22.623-20.865 29.216-26.795 28.829 36.775 8.173 60.351-17.346 62.97-29.92H26.56c-.583 0-1.04.51-1.013 1.091z",
  fill: "url(#white-rounded_svg__paint5_linear_1210_18321)"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint0_linear_1210_18321",
  x1: 36.557,
  y1: 5.392,
  x2: 4.746,
  y2: 35.738,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1E2837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#364459"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint3_linear_1210_18321",
  x1: 40.144,
  y1: 41.601,
  x2: 21.925,
  y2: -9.407,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B98CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint4_linear_1210_18321",
  x1: 37.149,
  y1: 16.345,
  x2: 49.597,
  y2: 47.314,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3DD0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#364AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint5_linear_1210_18321",
  x1: 37.149,
  y1: 16.345,
  x2: 49.597,
  y2: 47.314,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D7DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#4B3CFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "white-rounded_svg__paint1_radial_1210_18321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(-40.0003 0 0 -20.0001 39.887 19.859)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2D1E8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3321A4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "white-rounded_svg__paint2_radial_1210_18321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(-179.843 24.473 9.963) scale(49.0312 24.5155)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F0073"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2D00BE"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "white-rounded_svg__clip0_1210_18321"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#fff"
})))));
export default "data:image/svg+xml;base64,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";
export { SvgWhiteRounded as ReactComponent };